import {defineSlotRecipe} from '@chakra-ui/react3'

/** Shared centered play-button positioning for full video mode.
 *  Used by both the asset recipe and the accordion recipe.
 *  Video chrome sits above the in-module layers stacked over an asset, which
 *  run at 1-3, and below drawer and page chrome such as sticky CTA bars. */
export const fullVideoPlayButtonStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 'docked'
}

export const AUTOPLAY_BUTTON_VARIANT_MAP = {
    withDarken: 'mediaGhost',
    withoutDarken: 'secondaryGhost'
}

export const assetSlotRecipe = defineSlotRecipe({
    className: 'asset',
    slots: ['container', 'bottomGradient', 'videoControlBox', 'fullVideoPlayButton'],

    base: {
        container: {
            position: 'relative',
            w: '100%',
            h: '100%'
        },
        bottomGradient: {
            position: 'absolute',
            bottom: '0',
            left: '0',
            right: '0',
            height: '10.219rem',
            bg: 'gradient.bottom.darken-40',
            pointerEvents: 'none'
        },
        videoControlBox: {
            position: 'absolute',
            zIndex: 'docked',
            bottom: 'spacing-16',
            right: 'spacing-16'
        },
        fullVideoPlayButton: fullVideoPlayButtonStyle
    },
    variants: {
        darken: {
            '0%': {
                bottomGradient: {display: 'none'}
            },
            '40%': {
                bottomGradient: {bg: 'gradient.bottom.darken-40'}
            },
            '80%': {
                bottomGradient: {bg: 'gradient.bottom.darken-80'}
            },
            '100%': {
                bottomGradient: {bg: 'gradient.bottom.darken-100'}
            }
        },
        variant: {
            gallery: {
                videoControlBox: {
                    top: {base: 'spacing-24', s: 'auto'},
                    bottom: {base: 'auto', s: 'spacing-24'},
                    right: 'spacing-24'
                }
            },
            videoWithInfo: {
                videoControlBox: {
                    display: 'flex',
                    gap: 3,
                    alignItems: 'center',
                    left: 'spacing-16',
                    right: 'auto'
                }
            },
            cockpitGallery: {
                videoControlBox: {
                    right: 'auto',
                    bottom: {base: 'spacing-10', s: 'spacing-16'},
                    left: {base: 'spacing-10', s: 'spacing-16'}
                },
                bottomGradient: {display: 'none'}
            },
            configuratorQuickview: {
                container: {
                    aspectRatio: '1',
                    overflow: 'hidden'
                },
                videoControlBox: {
                    right: 'auto',
                    bottom: {base: 'spacing-10', s: 'spacing-16'},
                    left: {base: 'spacing-10', s: 'spacing-16'}
                },
                bottomGradient: {display: 'none'}
            }
        }
    },

    defaultVariants: {
        variant: 'default',
        darken: '40%'
    }
})
